import FormattedMessage from 'I18n/components/FormattedMessage';
import { BackButton } from 'foundations-components/transitional/components/BackButton';
import { Button } from 'foundations-components/transitional/components/Button';
//@ts-expect-error Untyped Dependency

import ObjectPropertiesFilter from './ObjectPropertiesFilter';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const FilterEditor = ({
  properties,
  objectTypeId,
  currentFilter,
  apply,
  cancel,
  isMultiFilterAllowed = true
}) => {
  return /*#__PURE__*/_jsxs("div", {
    "data-test-id": "journey-property-filter-editor",
    children: [isMultiFilterAllowed && /*#__PURE__*/_jsx(BackButton, {
      role: "button",
      "data-test-id": "journey-property-filter-back-button",
      children: /*#__PURE__*/_jsx(Button, {
        use: "transparent",
        onClick: cancel,
        padding: "0",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "reporting-enablement.reportEditors.journeyPropertyFilter.back"
        })
      })
    }), /*#__PURE__*/_jsx(ObjectPropertiesFilter, {
      properties: properties,
      objectTypeId: objectTypeId,
      currentValue: currentFilter,
      onApply: apply,
      onCancel: cancel
    })]
  });
};
export default FilterEditor;